// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthProvider, AuthContext } from "./AuthContext";
import Login from "./Login";
import Register from "./Register";
import Dashboard from "./Dashboard";

function AppRoutes() {
  const { user } = useContext(AuthContext);
  const [showRegister, setShowRegister] = useState(false);

  // Protected Route
  const PrivateRoute = ({ children }) => {
    return user?.email ? children : <Navigate to="/" />;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          showRegister ? (
            <Register switchToLogin={() => setShowRegister(false)} />
          ) : (
            <Login switchToRegister={() => setShowRegister(true)} />
          )
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}